import React from "react";
export const Footer = () => {
  return (
    <footer className={"l-footer"}>
      <div className={"l-footer-inner"}></div>
    </footer>
  );
};
